import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "../modules/auth/components/AuthInit";
import { AuthWrapper } from "../pages/auth/AuthWrapper";
import { GamePlayWrapper } from "../pages/gamePlay/GamePlayWrapper";
import { PrivateRoutes } from "./HomeRoutes";

const { PUBLIC_URL } = process.env;

const AppRoutes = () => {
  const { auth } = useAuth();
  const queryParameters = new URLSearchParams(window.location.search);
  const platform = queryParameters.get("platform");
  if (platform && platform.trim() !== "") {
    sessionStorage.setItem("platform", platform);
  }
  const telegramID = queryParameters.get("userid");
  if (platform && platform.trim() !== "") {
    sessionStorage.setItem("telegramID", telegramID);
  }

  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        {
          auth ? (
            <>
              <Route path="/*" element={<PrivateRoutes />} />
              <Route
                index
                element={
                  <Navigate
                    to={"/home"}
                  />
                }
              />
            </>
          ) : (
            <>
              <Route
                path="gamePlay/*"
                element={<GamePlayWrapper isDemo={true} />}
              />
              <Route path="/*" element={<AuthWrapper />} />
              {platform === "telegram" ? (
                <Route path="*" element={<Navigate to="/loginchoose" />} />
              ) : (
                <Route path="*" element={<Navigate to="/login" />} />
              )}
            </>
          )}
      </Routes>
    </BrowserRouter>
  );
};

export { AppRoutes };

